// scans HTML for timestamps like (MM:SS) or (MM:SS - MM:SS) or (MM:SS–MM:SS) or (MM:SS—MM:SS) 
// converts them into clickable spans with data attributes for the start time in seconds
// accepts hyphen, en dash, and em dash as separators
// also handles multiple comma-separated ranges in one group, e.g. (MM:SS-MM:SS, MM:SS-MM:SS)

const parseTimestampToSeconds = (timestamp) => {
    if (!timestamp) return 0
    const match = timestamp.match(/(\d+):(\d+(?:\.\d+)?)/)
    if (match) {
        const mins = parseInt(match[1], 10)
        const secs = parseFloat(match[2])
        return mins * 60 + secs
    }
    return 0
}

const formatDisplayTimestamp = (timestamp) => timestamp.split('.')[0]

const TIMESTAMP = '\\d+:\\d+(?:\\.\\d+)?'
const RANGE = `${TIMESTAMP}(?:\\s*[-–—]\\s*${TIMESTAMP})?`
const GROUP_RE = new RegExp(`\\((${RANGE}(?:\\s*,\\s*${RANGE})*)\\)`, 'g')
const RANGE_RE = new RegExp(`^(${TIMESTAMP})(?:\\s*([-–—])\\s*(${TIMESTAMP}))?$`)

const linkifyRange = (part) => {
    const rangeMatch = part.trim().match(RANGE_RE)
    if (!rangeMatch) return part.trim()
    const [, start, dash, end] = rangeMatch
    const startSpan = `<span class="timestamp-link" data-start="${parseTimestampToSeconds(start)}">${formatDisplayTimestamp(start)}</span>`
    if (!end) return startSpan
    const endSpan = `<span class="timestamp-link" data-start="${parseTimestampToSeconds(end)}">${formatDisplayTimestamp(end)}</span>`
    return `${startSpan}${dash}${endSpan}`
}

export const makeTimestampsClickable = (html) => {
    if (!html) return html
    return html.replace(GROUP_RE, (match, inner) => {
        const parts = inner.split(',').map(linkifyRange)
        return `(${parts.join(', ')})`
    })
}

export const handleTimestampLinkClick = (e, onTimestampClick) => {
    const target = e.target.closest('.timestamp-link')
    if (target && onTimestampClick) {
        const startSeconds = parseFloat(target.dataset.start)
        onTimestampClick(startSeconds)
    }
}
